import { createApiClient } from '@room/frontend-sdk';

const apiClient = createApiClient({
  baseURL: '/api',
});

export const api = {
  get: <T = unknown>(url: string) => apiClient.get<T>(url),
  post: <T = unknown>(url: string, data?: unknown) => apiClient.post<T>(url, data),
  put: <T = unknown>(url: string, data?: unknown) => apiClient.put<T>(url, data),
  patch: <T = unknown>(url: string, data?: unknown) => apiClient.patch<T>(url, data),
  delete: <T = unknown>(url: string) => apiClient.delete<T>(url),
};
